import React, { useState, useEffect } from 'react';

// Import Scss
import './assets/scss/themes.scss';

// Import Route
import Route from './Routes';

// Fake Backend 
import fakeBackend from "./helpers/AuthType/fakeBackend";
import { GoogleReCaptchaProvider } from 'react-google-recaptcha-v3';
import config from './config';
import { get_Models } from './helpers/fakebackend_helper';
import Maintenance from './pages/Pages/Maintenance/Maintenance';

// Activating fake backend
fakeBackend();

function App() {
  // const [isUnderMaintenance, setIsUnderMaintenance] = useState(false);

  // useEffect(() => {
  //   // Check if the backend API is available (simulate with a dummy check)
  //   const checkApiStatus = async () => {
  //     try {
  //       const response = await get_Models() // Replace with actual backend endpoint
  //       // if (!response.ok) {
  //       //   throw new Error('API not working');
  //       // }
  //       // You can handle successful response if needed
  //     } catch (error) {
  //       console.error(error);
  //       setIsUnderMaintenance(true); // If API fails, set maintenance mode
  //     }
  //   };

  //   checkApiStatus();
  // }, []);

  // if (isUnderMaintenance) {
  //   return (
  //      <Maintenance/>
  //   );
  // }

  return (
    <React.Fragment>
      <Route />
    </React.Fragment>
  );
}

export default App;
